import { createFileRoute } from '@tanstack/react-router';
import { NomenclatorScreen } from '../../../features/settings/nomenclator-screen';

/** Ecranul e comun celor trei nomenclatoare; ruta doar alege care. */
export const Route = createFileRoute('/_authenticated/setari/tipuri-pachet')({
  component: () => <NomenclatorScreen kind="tipuri-pachet" />,
});
